import type { Card } from './data/cards/types';

/**
 * Snowball engine — Plaque tag primitive.
 *
 * A "tag" is the atomic Snowball action. Applying a tag means:
 *   1. The target gains +1/+1 permanently (mutates attack + health).
 *   2. The target's plaqueStacks counter increments by 1.
 *
 * The +1/+1 is the gameplay payoff; the counter is what finishers like
 * La Leyenda Tatuada cash in at start_of_combat.
 *
 * Mutates the card in place — call this on a CardInstance, not a Card from
 * the read-only data layer.
 */
export function applyPlaqueTag(card: Card, count = 1): void {
  if (count <= 0) return;
  card.attack += count;
  card.health += count;
  card.plaqueStacks = (card.plaqueStacks ?? 0) + count;
}

/**
 * Reads the plaque stack count for cash-in calculations. Treats undefined as 0
 * so a fresh card without any tags returns a clean zero.
 */
export function getPlaqueStacks(card: Card): number {
  return card.plaqueStacks ?? 0;
}
